import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  broker: '',
  exchange: 'NSE',
  segment: 'Options',
  symbol: 'NSE_INDEX|Nifty 50',
  expiryDate: '2025-06-05',
  callStrike: '',
  putStrike: '',
  quantity: '50',
  productType: 'Margin',
  orderType: 'Market',
  marketProtection: '10',
  positionType: 'F&O positions only',
};

const tradeWindowSlice = createSlice({
  name: 'tradeWindow',
  initialState,
  reducers: {
    setField: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    resetForm: () => initialState,
  },
});

export const { setField, resetForm } = tradeWindowSlice.actions;
export default tradeWindowSlice.reducer;